module.exports = __webpack_public_path__ + "media/images/youth_citizens_science/logo_banner/image 006-6e6f71bb41d4f1f7097922f6c4628b69.png";